/**************************************************
 * Nombre:       Formulario_Contenido_Caps_Contenido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {FlagOutlined, Title} from "@mui/icons-material";
import {useState} from "react";
import {TIPOSCONTENIDO} from "../../../Constantes";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoSelectFuncion from "../../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import IngresoVideo from "../../../Modulo_formularios/Componentes/IngresoVideo";
import IngresoPdf from "../../../Modulo_formularios/Componentes/IngresoPdf";
import IngresoImagen from "../../../Modulo_formularios/Componentes/IngresoImagen";

const Formulario_Contenido_Caps_Contenido = ({...props}) => {
    const [tipo, setTipo] = useState({});

    const mostrarTipo = (tip) => {

        switch (tip) {
            case TIPOSCONTENIDO[0] :  //video
                return (
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <IngresoVideo dato={'recurso'} {...props}/>
                    </Grid>
                )
                break
            case TIPOSCONTENIDO[1] :  //pdf
                return (
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <IngresoPdf dato={'recurso'} {...props}/>
                    </Grid>
                )
                break
            case TIPOSCONTENIDO[2] :  //imagen
                return (
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <IngresoImagen dato={'recurso'} {...props}/>
                    </Grid>
                )
                break

            case TIPOSCONTENIDO[3] :  //imagen
                return (
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <IngresoTexto dato={'recurso'} nombre={'ID del video '} {...props} ejemplo={'Fvtn8kyIejo'}/>
                    </Grid>
                )
                break
        }

    }

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={Title} nombre={'Titulo'} dato={'titulo'} {...props}
                                  requerido={'El titulo es requerido'}
                    />
                </Grid>

                <Grid container size={12} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto lineas={4} nombre={'Descripcion'} dato={'descripcion'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelectFuncion Icono={FlagOutlined} nombre={'Tipo'} dato={'tipo'} {...props}
                                          requerido={'El tipo es requerido'}
                                          opciones={TIPOSCONTENIDO} setDato={setTipo}
                    />
                </Grid>

                {mostrarTipo(tipo)}


            </Grid>

        </form>

    )

}
export default Formulario_Contenido_Caps_Contenido